import { ElementRef } from '@angular/core';

export class ArraySectionDirectiveModel {
	section: string | null;
	indexes: number[];
	cssClass: string | null;
	skipDirective: boolean;
	visible: boolean;
	rendered: boolean;
	lazy?: boolean;
	component?: DirectiveDataComponent;
	metadata?: any;

	constructor() {
		this.section = null;
		this.indexes = [];
		this.cssClass = null;
		this.skipDirective = false;
		this.visible = false;
		this.rendered = false;
	}
}

export class DirectiveDataComponent {
	retain?: any;
	dispose?: any;
	metaData?: any;
}

export class ScrollableItemModel {
	id: string;
	cssClass?: string | null;
	element?: ElementRef;
	visible?: boolean;
	rendered?: boolean;
	section?: string;
	metadata?: any;
	component?: any;
}

export class ExtendedSectionOptions {
	skipDirective?: boolean; // to avoid the repeated information in the array of elements of a section
	rootWidget?: RootWidgetOptions; // its an object to add options to the extended-root-widget component
}

export class RootWidgetOptions {
	htmlClass?: string; // html classes to apply to the extended-section->extended-root-widget
	itemHtmlClass?: string; // html classes to apply to the first div's (FOR cycle) of the extended-root-widget
	ignoreFlexAttrs?: boolean; // value to ignore the flex attrs calulated by the function getFlexAttribute()
	title?: string; // title for the section instead of the the default one nor the rootWidget
	condition?: ((...any) => any) | string; // condition to show/hide some information
}

export class NewItemData {
	refPath: string;
	isArrayItem: boolean;
	dataIndex?: number[];
}

export class AjsfNewItem {
	formGroup: any;
	index: boolean | number;
}